<template>
  <dialog-add
    icon="inventory"
    :title="$t('create_event_promotion')"
    is-fullscreen
    :is-on="true"
    :on-close="onCancel"
    class="promotion-theming-dialog"
  >
    <template v-slot:content>
      <forms-events-promotion-theming class="elevation-1" @saved="$emit('saved')" />
    </template>
  </dialog-add>
</template>

<script>
export default {
  emits: ['saved'],
  methods: {
    onCancel() {
      const { step, ...listQuery } = this.$route.query;
      this.$router.push({ name: 'event-promotions', query: listQuery });
    },
  },
};
</script>
